import {
  CourseMaterial,
  TermLite,
  useCoursesLoaderData,
} from "./coursesLoader";

export function getOptedIn(material: CourseMaterial, currentTerm?: TermLite) {
  switch (currentTerm?.programDecision) {
    case "equitable_access":
      return true;
    case "inclusive_access":
      return !material.optOut;
    case "no_program":
      return false;
  }
}

export default function useOptedIn(material: CourseMaterial) {
  const { currentTerm } = useCoursesLoaderData();
  return getOptedIn(material, currentTerm);
}
